<div class="inputFiled__container">
    <label class="{{labelClass || 'inputField__label'}}" for="tataSteel">{{label}}<span *ngIf="starIcon"
            class="spmred">{{starIcon}}</span></label>
    <input [formControl]="control" class="inputFiled__tataSteel" (keydown)="onKeyDown($event, label)"  appNoLeadingSpaces
        placeholder={{placeholder}} value={{value}} type="{{type}}" [disabled]="disabled"
        (ngModelChange)="onChange($event)">
</div>